import { createReducer, on } from '@ngrx/store';
import { initialState } from './assets.state';
import * as AssetsActions from './assets.actions';

export const assetsReducer = createReducer(
    initialState,

    // Pavement
    on(AssetsActions.findPavements, state => ({ ...state, loading: true, error: null })),
    on(AssetsActions.findPavementsSuccess, (state, { result }) => ({ ...state, pavementResult: result, loading: false })),
    on(AssetsActions.findPavementsFailure, (state, { error }) => ({ ...state, loading: false, error })),

    // Bollard
    on(AssetsActions.findBollards, state => ({ ...state, loading: true, error: null })),
    on(AssetsActions.findBollardsSuccess, (state, { result }) => ({ ...state, bollardResult: result, loading: false })),
    on(AssetsActions.findBollardsFailure, (state, { error }) => ({ ...state, loading: false, error })),

    // Bridge
    on(AssetsActions.findBridges, state => ({ ...state, loading: true, error: null })),
    on(AssetsActions.findBridgesSuccess, (state, { result }) => ({ ...state, bridgeResult: result, loading: false })),
    on(AssetsActions.findBridgesFailure, (state, { error }) => ({ ...state, loading: false, error })),

    // BusStop
    on(AssetsActions.findBusStops, state => ({ ...state, loading: true, error: null })),
    on(AssetsActions.findBusStopsSuccess, (state, { result }) => ({ ...state, busStopResult: result, loading: false })),
    on(AssetsActions.findBusStopsFailure, (state, { error }) => ({ ...state, loading: false, error })),

    // DrainageCover
    on(AssetsActions.findDrainageCovers, state => ({ ...state, loading: true, error: null })),
    on(AssetsActions.findDrainageCoversSuccess, (state, { result }) => ({ ...state, drainageCoverResult: result, loading: false })),
    on(AssetsActions.findDrainageCoversFailure, (state, { error }) => ({ ...state, loading: false, error })),

    // Drainage
    on(AssetsActions.findDrainages, state => ({ ...state, loading: true, error: null })),
    on(AssetsActions.findDrainagesSuccess, (state, { result }) => ({ ...state, drainageResult: result, loading: false })),
    on(AssetsActions.findDrainagesFailure, (state, { error }) => ({ ...state, loading: false, error })),

    // Fence
    on(AssetsActions.findFences, state => ({ ...state, loading: true, error: null })),
    on(AssetsActions.findFencesSuccess, (state, { result }) => ({ ...state, fenceResult: result, loading: false })),
    on(AssetsActions.findFencesFailure, (state, { error }) => ({ ...state, loading: false, error })),

    // GeoTechStructure
    on(AssetsActions.findGeoTechStructures, state => ({ ...state, loading: true, error: null })),
    on(AssetsActions.findGeoTechStructuresSuccess, (state, { result }) => ({ ...state, geoTechStructureResult: result, loading: false })),
    on(AssetsActions.findGeoTechStructuresFailure, (state, { error }) => ({ ...state, loading: false, error })),

    // Guardrail
    on(AssetsActions.findGuardrails, state => ({ ...state, loading: true, error: null })),
    on(AssetsActions.findGuardrailsSuccess, (state, { result }) => ({ ...state, guardrailResult: result, loading: false })),
    on(AssetsActions.findGuardrailsFailure, (state, { error }) => ({ ...state, loading: false, error })),

    // MultipurposeHall
    on(AssetsActions.findMultipurposeHalls, state => ({ ...state, loading: true, error: null })),
    on(AssetsActions.findMultipurposeHallsSuccess, (state, { result }) => ({ ...state, multipurposeHallResult: result, loading: false })),
    on(AssetsActions.findMultipurposeHallsFailure, (state, { error }) => ({ ...state, loading: false, error })),

    // Parking
    on(AssetsActions.findParking, state => ({ ...state, loading: true, error: null })),
    on(AssetsActions.findParkingSuccess, (state, { result }) => ({ ...state, parkingResult: result, loading: false })),
    on(AssetsActions.findParkingFailure, (state, { error }) => ({ ...state, loading: false, error })),

    // PublicToilet
    on(AssetsActions.findPublicToilets, state => ({ ...state, loading: true, error: null })),
    on(AssetsActions.findPublicToiletsSuccess, (state, { result }) => ({ ...state, publicToiletResult: result, loading: false })),
    on(AssetsActions.findPublicToiletsFailure, (state, { error }) => ({ ...state, loading: false, error })),

    // RoadKerb
    on(AssetsActions.findRoadKerbs, state => ({ ...state, loading: true, error: null })),
    on(AssetsActions.findRoadKerbsSuccess, (state, { result }) => ({ ...state, roadKerbResult: result, loading: false })),
    on(AssetsActions.findRoadKerbsFailure, (state, { error }) => ({ ...state, loading: false, error })),

    // RoadMarking
    on(AssetsActions.findRoadMarkings, state => ({ ...state, loading: true, error: null })),
    on(AssetsActions.findRoadMarkingsSuccess, (state, { result }) => ({ ...state, roadMarkingResult: result, loading: false })),
    on(AssetsActions.findRoadMarkingsFailure, (state, { error }) => ({ ...state, loading: false, error })),

    // TrafficLight
    on(AssetsActions.findTrafficLights, state => ({ ...state, loading: true, error: null })),
    on(AssetsActions.findTrafficLightsSuccess, (state, { result }) => ({ ...state, trafficLightResult: result, loading: false })),
    on(AssetsActions.findTrafficLightsFailure, (state, { error }) => ({ ...state, loading: false, error })),

    // TrafficSign
    on(AssetsActions.findTrafficSigns, state => ({ ...state, loading: true, error: null })),
    on(AssetsActions.findTrafficSignsSuccess, (state, { result }) => ({ ...state, trafficSignResult: result, loading: false })),
    on(AssetsActions.findTrafficSignsFailure, (state, { error }) => ({ ...state, loading: false, error })),

    // Walkway
    on(AssetsActions.findWalkways, state => ({ ...state, loading: true, error: null })),
    on(AssetsActions.findWalkwaysSuccess, (state, { result }) => ({ ...state, walkwayResult: result, loading: false })),
    on(AssetsActions.findWalkwaysFailure, (state, { error }) => ({ ...state, loading: false, error })),

    // BinCentre
    on(AssetsActions.findBinCentres, state => ({ ...state, loading: true, error: null })),
    on(AssetsActions.findBinCentresSuccess, (state, { result }) => ({ ...state, binCentreResult: result, loading: false })),
    on(AssetsActions.findBinCentresFailure, (state, { error }) => ({ ...state, loading: false, error })),

    // MaintenanceAsset
    on(AssetsActions.findMaintenanceAssets, state => ({ ...state, loading: true, error: null })),
    on(AssetsActions.findMaintenanceAssetsSuccess, (state, { result }) => ({ ...state, maintenanceAssetResult: result, loading: false })),
    on(AssetsActions.findMaintenanceAssetsFailure, (state, { error }) => ({ ...state, loading: false, error })),

    // Handle Create/Update/Delete Success if needed (to maybe reload data or clear errors)
    // For now, simple error setting on failure.
    on(
        AssetsActions.createPavement, AssetsActions.updatePavement, AssetsActions.deletePavement,
        AssetsActions.createBollard, AssetsActions.updateBollard, AssetsActions.deleteBollard,
        AssetsActions.createBridge, AssetsActions.updateBridge, AssetsActions.deleteBridge,
        AssetsActions.createBusStop, AssetsActions.updateBusStop, AssetsActions.deleteBusStop,
        AssetsActions.createDrainageCover, AssetsActions.updateDrainageCover, AssetsActions.deleteDrainageCover,
        AssetsActions.createDrainage, AssetsActions.updateDrainage, AssetsActions.deleteDrainage,
        AssetsActions.createFence, AssetsActions.updateFence, AssetsActions.deleteFence,
        AssetsActions.createGeoTechStructure, AssetsActions.updateGeoTechStructure, AssetsActions.deleteGeoTechStructure,
        AssetsActions.createGuardrail, AssetsActions.updateGuardrail, AssetsActions.deleteGuardrail,
        AssetsActions.createMultipurposeHall, AssetsActions.updateMultipurposeHall, AssetsActions.deleteMultipurposeHall,
        AssetsActions.createParking, AssetsActions.updateParking, AssetsActions.deleteParking,
        AssetsActions.createPublicToilet, AssetsActions.updatePublicToilet, AssetsActions.deletePublicToilet,
        AssetsActions.createRoadKerb, AssetsActions.updateRoadKerb, AssetsActions.deleteRoadKerb,
        AssetsActions.createRoadMarking, AssetsActions.updateRoadMarking, AssetsActions.deleteRoadMarking,
        AssetsActions.createTrafficLight, AssetsActions.updateTrafficLight, AssetsActions.deleteTrafficLight,
        AssetsActions.createTrafficSign, AssetsActions.updateTrafficSign, AssetsActions.deleteTrafficSign,
        AssetsActions.createWalkway, AssetsActions.updateWalkway, AssetsActions.deleteWalkway,
        AssetsActions.createBinCentre, AssetsActions.updateBinCentre, AssetsActions.deleteBinCentre,
        AssetsActions.createMaintenanceAsset, AssetsActions.updateMaintenanceAsset, AssetsActions.deleteMaintenanceAsset,
        (state) => ({ ...state, loading: true, error: null })
    ),
    on(
        AssetsActions.createPavementFailure, AssetsActions.updatePavementFailure, AssetsActions.deletePavementFailure,
        AssetsActions.createBollardFailure, AssetsActions.updateBollardFailure, AssetsActions.deleteBollardFailure,
        AssetsActions.createBridgeFailure, AssetsActions.updateBridgeFailure, AssetsActions.deleteBridgeFailure,
        AssetsActions.createBusStopFailure, AssetsActions.updateBusStopFailure, AssetsActions.deleteBusStopFailure,
        AssetsActions.createDrainageCoverFailure, AssetsActions.updateDrainageCoverFailure, AssetsActions.deleteDrainageCoverFailure,
        AssetsActions.createDrainageFailure, AssetsActions.updateDrainageFailure, AssetsActions.deleteDrainageFailure,
        AssetsActions.createFenceFailure, AssetsActions.updateFenceFailure, AssetsActions.deleteFenceFailure,
        AssetsActions.createGeoTechStructureFailure, AssetsActions.updateGeoTechStructureFailure, AssetsActions.deleteGeoTechStructureFailure,
        AssetsActions.createGuardrailFailure, AssetsActions.updateGuardrailFailure, AssetsActions.deleteGuardrailFailure,
        AssetsActions.createMultipurposeHallFailure, AssetsActions.updateMultipurposeHallFailure, AssetsActions.deleteMultipurposeHallFailure,
        AssetsActions.createParkingFailure, AssetsActions.updateParkingFailure, AssetsActions.deleteParkingFailure,
        AssetsActions.createPublicToiletFailure, AssetsActions.updatePublicToiletFailure, AssetsActions.deletePublicToiletFailure,
        AssetsActions.createRoadKerbFailure, AssetsActions.updateRoadKerbFailure, AssetsActions.deleteRoadKerbFailure,
        AssetsActions.createRoadMarkingFailure, AssetsActions.updateRoadMarkingFailure, AssetsActions.deleteRoadMarkingFailure,
        AssetsActions.createTrafficLightFailure, AssetsActions.updateTrafficLightFailure, AssetsActions.deleteTrafficLightFailure,
        AssetsActions.createTrafficSignFailure, AssetsActions.updateTrafficSignFailure, AssetsActions.deleteTrafficSignFailure,
        AssetsActions.createWalkwayFailure, AssetsActions.updateWalkwayFailure, AssetsActions.deleteWalkwayFailure,
        AssetsActions.createBinCentreFailure, AssetsActions.updateBinCentreFailure, AssetsActions.deleteBinCentreFailure,
        AssetsActions.createMaintenanceAssetFailure, AssetsActions.updateMaintenanceAssetFailure, AssetsActions.deleteMaintenanceAssetFailure,
        (state, { error }) => ({ ...state, loading: false, error })
    ),
    on(
        AssetsActions.createPavementSuccess, AssetsActions.updatePavementSuccess, AssetsActions.deletePavementSuccess,
        AssetsActions.createBollardSuccess, AssetsActions.updateBollardSuccess, AssetsActions.deleteBollardSuccess,
        AssetsActions.createBridgeSuccess, AssetsActions.updateBridgeSuccess, AssetsActions.deleteBridgeSuccess,
        AssetsActions.createBusStopSuccess, AssetsActions.updateBusStopSuccess, AssetsActions.deleteBusStopSuccess,
        AssetsActions.createDrainageCoverSuccess, AssetsActions.updateDrainageCoverSuccess, AssetsActions.deleteDrainageCoverSuccess,
        AssetsActions.createDrainageSuccess, AssetsActions.updateDrainageSuccess, AssetsActions.deleteDrainageSuccess,
        AssetsActions.createFenceSuccess, AssetsActions.updateFenceSuccess, AssetsActions.deleteFenceSuccess,
        AssetsActions.createGeoTechStructureSuccess, AssetsActions.updateGeoTechStructureSuccess, AssetsActions.deleteGeoTechStructureSuccess,
        AssetsActions.createGuardrailSuccess, AssetsActions.updateGuardrailSuccess, AssetsActions.deleteGuardrailSuccess,
        AssetsActions.createMultipurposeHallSuccess, AssetsActions.updateMultipurposeHallSuccess, AssetsActions.deleteMultipurposeHallSuccess,
        AssetsActions.createParkingSuccess, AssetsActions.updateParkingSuccess, AssetsActions.deleteParkingSuccess,
        AssetsActions.createPublicToiletSuccess, AssetsActions.updatePublicToiletSuccess, AssetsActions.deletePublicToiletSuccess,
        AssetsActions.createRoadKerbSuccess, AssetsActions.updateRoadKerbSuccess, AssetsActions.deleteRoadKerbSuccess,
        AssetsActions.createRoadMarkingSuccess, AssetsActions.updateRoadMarkingSuccess, AssetsActions.deleteRoadMarkingSuccess,
        AssetsActions.createTrafficLightSuccess, AssetsActions.updateTrafficLightSuccess, AssetsActions.deleteTrafficLightSuccess,
        AssetsActions.createTrafficSignSuccess, AssetsActions.updateTrafficSignSuccess, AssetsActions.deleteTrafficSignSuccess,
        AssetsActions.createWalkwaySuccess, AssetsActions.updateWalkwaySuccess, AssetsActions.deleteWalkwaySuccess,
        AssetsActions.createBinCentreSuccess, AssetsActions.updateBinCentreSuccess, AssetsActions.deleteBinCentreSuccess,
        AssetsActions.createMaintenanceAssetSuccess, AssetsActions.updateMaintenanceAssetSuccess, AssetsActions.deleteMaintenanceAssetSuccess,
        (state) => ({ ...state, loading: false })
    )
);
